import { createIntl, createIntlCache } from 'react-intl';

import intlMessagesEN from './locales/en.json';
import intlMessagesES from './locales/es.json';
import intlMessagesFR from './locales/fr.json';
import intlMessagesPT from './locales/pt.json';
import intlMessagesESPE from './locales/es-pe.json';
import translations from './scripts/messagesDefinitions';

export const messages = {
  en: intlMessagesEN,
  es: intlMessagesES,
  fr: intlMessagesFR,
  pt: intlMessagesPT,
  'es-pe': { ...intlMessagesES, ...intlMessagesESPE }
};

export const getCurrentLanguage = () => localStorage.getItem('language') || 'es';

const normalizeLanguage = lang => {
  // Convert underscore to hyphen (e.g. es_mx -> es-mx) and lowercase
  const normalized = lang.replace(/_/g, '-').toLowerCase();
  // Return the language if it exists in messages, otherwise fall back to base language (e.g. es-mx -> es)
  if (messages[normalized]) return normalized;
  const base = normalized.split('-')[0];
  return messages[base] ? base : 'es';
};

const storedIntl = {};
const intlCache = createIntlCache();
const getIntl = currentLanguage => {
  const language = normalizeLanguage(currentLanguage);
  if (storedIntl.currentLanguage !== language) {
    storedIntl.currentLanguage = language;
    storedIntl.providerContext = createIntl(
      {
        locale: language,
        messages: messages[language]
      },
      intlCache
    );
  }
  return storedIntl.providerContext;
};

export const formatMessage = ({ id, values }) => {
  const { formatMessage: intlFormatMessage } = getIntl(getCurrentLanguage());
  const translationId = translations[id];
  if (process.env.NODE_ENV !== 'production') {
    if (!translationId) {
      console.error(`Missing translation for id: ${id}`);
      return `MISSING TRANSLATION: ${id}`;
    }
  }

  return intlFormatMessage(translationId, values);
};
